import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { documentPrintModalActions, DocumentPrintStep } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { useCallback } from 'react';
import { DocumentPrintOrderType } from '@/Enums/DocumentPrintOrderType';
import { printService } from '@/Electron';
import { useDocumentPrintModalActions } from '@/ModalWindows/DocumentPrintModal/hooks/useDocumentPrintModalActions';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';
import { DocumentTemplateRow } from '@/Types';

export const useSelectDocumentModal = (onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const documentType = useSelector(documentPrintModalSelectors.documentType);
  const selectedTypeNumbers = useSelector(documentPrintModalSelectors.selectedTypeNumbers);
  const selectedNumbersInfo = useSelector(documentPrintModalSelectors.selectedNumbersInfo);

  const { printDocuments } = useDocumentPrintModalActions();

  const backPreviousStep = () => {
    dispatch(documentPrintModalActions.setDocumentPrintStep(DocumentPrintStep.SelectTemplate));
  };

  const onPrint = useCallback(
    async (documentTemplate: DocumentTemplateRow) => {
      if (!documentType) return;

      const printUnionPdfModels = selectedNumbersInfo.map(({ documentNumber, countCopy }) => ({
        orderNumber: documentNumber,
        countCopy: countCopy,
        orderId: selectedTypeNumbers[0].orderId,
      }));

      const { countCopy, isSortWhenPrinting } = documentTemplate;
      const needSort = isSortWhenPrinting && countCopy != 1;
      const printOrder = DocumentPrintOrderType.DocumentNumber;

      const document = await DocumentTemplateApi.printUnionPdfFiles({
        printUnionPdfModels,
        numberGenerationType: documentType,
        documentPrintOrderType: needSort ? printOrder : undefined,
      });

      printService.printDocument(document, documentTemplate.guid);

      onClose();
    },
    [documentType, selectedNumbersInfo, selectedTypeNumbers],
  );

  const onPrintSelectedDocuments = () => {
    printDocuments(onPrint);
  };

  return {
    onPrintSelectedDocuments,
    backPreviousStep,
  };
};
